/* eslint-disable import/prefer-default-export */

import { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

import { fetchStateInfo } from './apiActionCreators'
import {
  GEOCODE_FAILURE,
  GEOCODE_LATLNG_SUCCESS,
  GEOCODE_REQUEST,
  GEOCODE_SUCCESS,
} from '../constants/officeRunnerConstants'

/**
 * Get the value for a given key in address_components
 *
 * Source: https://stackoverflow.com/a/40144130
 *
 * @param {Array} components address_components returned from Google maps autocomplete
 * @param type key for desired address component
 * @returns {String} value, if found, for given type (key)
 */
const extractFromAddress = (components, type) => (
  components
    .filter(c => c.types.indexOf(type) === 0)
    .map(item => item.short_name)
    .pop()
)

export const geocodeAddressFailure = error => (
  { type: GEOCODE_FAILURE, error }
)

export const geocodeAddressRequest = () => (
  { type: GEOCODE_REQUEST }
)

export const geocodeAddressSuccess = result => (
  { type: GEOCODE_SUCCESS, result }
)

export const geocodeLatLngSuccess = latLng => (
  { type: GEOCODE_LATLNG_SUCCESS, latLng }
)

export const geocodeAddress = address => (
  dispatch => {
    dispatch(geocodeAddressRequest())
    return geocodeByAddress(address)
      .then(results => {
        const result = results[0]
        const components = result.address_components
        const state = extractFromAddress(components, 'administrative_area_level_1')

        dispatch(geocodeAddressSuccess({
          city: extractFromAddress(components, 'locality'),
          country: extractFromAddress(components, 'country'),
          postal_code: extractFromAddress(components, 'postal_code'),
          state,
          street: extractFromAddress(components, 'route'),
          street_number: extractFromAddress(components, 'street_number'),
        }))

        if (state) {
          dispatch(fetchStateInfo(state))
        }

        return getLatLng(result)
      })
      .then(latLng => dispatch(geocodeLatLngSuccess(latLng)))
      .catch(error => dispatch(geocodeAddressFailure(error)))
  }
)



// WEBPACK FOOTER //
// ./src/actions/geocodeActionCreators.js